
    <div class="theme-options-panel" fusePerfectScrollbar>
      <ng-container #content></ng-container>
    </div>
  